/**
 * Van Moose Landing Core
 *
 * A high-converting landing page component library inspired by Linear's marketing site.
 * Built for the Van Moose SaaS ecosystem.
 */

// Layout Components
export {
  LandingShell,
  Navbar,
  Footer,
  Section,
  Container
} from './components/layout'

// Hero Components
export {
  HeroSimple,
  HeroWithProduct,
  HeroSplit,
  HeroMinimal
} from './components/hero'

// Common Components
export {
  Button,
  Badge,
  Card,
  Screenshot,
  AvatarStack,
  BrandLogo,
  VanMooseLogo
} from './components/common'

// Motion Components
export {
  FadeIn,
  SlideIn,
  StaggerChildren,
  GridBackground
} from './components/motion'

// Section Components
export {
  LogoCloud,
  FeatureGrid,
  FeatureShowcase,
  FeatureBento,
  Testimonials,
  Pricing,
  FAQ,
  CTABanner,
  HowItWorks
} from './components/sections'

// Page Templates
export {
  ContactPage,
  AboutPage,
  BlogPage,
  DocsPage,
  PrivacyPage,
  TermsPage
} from './components/pages'

// Types
export type {
  // Layout Types
  NavLink,
  NavbarProps,
  FooterColumn,
  SocialLink,
  FooterProps,
  SectionProps,
  ContainerProps,
  LandingShellProps,

  // Hero Types
  HeroBadge,
  HeroCTA,
  HeroScreenshot,
  HeroSimpleProps,
  HeroWithProductProps,
  HeroSplitProps,
  HeroMinimalProps,

  // Section Types
  Logo,
  LogoCloudProps,
  Feature,
  FeatureGridProps,
  ShowcaseFeature,
  FeatureShowcaseProps,
  BentoItem,
  FeatureBentoProps,
  Testimonial,
  TestimonialsProps,
  Plan,
  PricingProps,
  FAQItem,
  FAQProps,
  CTABannerProps,
  Step,
  HowItWorksProps,

  // Common Types
  ButtonProps,
  BadgeProps,
  CardProps,
  ScreenshotProps,
  AvatarStackProps,
  BrandLogoProps,
  VanMooseLogoProps,

  // Motion Types
  FadeInProps,
  SlideInProps,
  StaggerChildrenProps,
  GridBackgroundProps
} from './types'

// Utility
export { cn } from './utils/cn'
